import { parsePhoneNumber } from 'awesome-phonenumber';
import { number, object, ObjectSchema, string } from 'yup';

import { FormErrorMessage } from '~/constants/messages';
import { postalCodeRegexp } from '~/constants/regexp';

import { Fields } from './types';

export const validationSchema: ObjectSchema<Fields> = object({
  name: string().label('店舗名').required(FormErrorMessage.required),
  pharmacyCode: string()
    .label('薬局コード')
    .matches(/^\d{10}$/, FormErrorMessage.pharmacyCodeInvalid)
    .nullable()
    .default(null),
  city: string().label('市区町村').required(FormErrorMessage.required),
  line: string().label('番地・マンション名').required(FormErrorMessage.required),
  postalCode: string()
    .label('郵便番号')
    .matches(postalCodeRegexp, FormErrorMessage.invalid)
    .required(FormErrorMessage.required),
  prefecture: string().label('都道府県').required(FormErrorMessage.required),
  tel: string()
    .label('電話番号')
    .required(FormErrorMessage.required)
    .test('tel', FormErrorMessage.invalid, (phone) => {
      return phone ? parsePhoneNumber(phone, { regionCode: 'JP' }).valid : false;
    }),
  fax: string()
    .label('FAX')
    .required(FormErrorMessage.required)
    .test('fax', FormErrorMessage.invalid, (fax) => {
      return fax ? parsePhoneNumber(fax, { regionCode: 'JP' }).valid : false;
    }),
  latitude: number().label('緯度/経度').required(FormErrorMessage.map),
  longitude: number().label('緯度/経度').required(FormErrorMessage.map),
});
